import { useState } from "react";
import { formatAndRaiseError } from "../helpers/general";
import { requestHelper } from "../helpers/request-helper";
import { HomePageContentType } from "../types/server";

export function useHomePageContent() {
  let [data, setData] = useState<HomePageContentType>();
  let [loading, setLoading] = useState(false);
  let [error, setError] = useState(null);

  function retrieve() {
    setLoading(true);
    setError(null);
    return requestHelper(
      `
          query homePage{
            homepage{
                promotions{
                  url
                  ratio
                  title
                  description
                  code
                }
                videos {
                  id
                  url
                  cover
                  ratio
                }
                promotionNewUsers {
                  code
                  title
                }
                appInfo {
                  min_version
                  max_version
                  required_version
                  phone
                  text
                }
              }
          }
        `
    )
      .then((data) => {
        setData(data.homepage);
      })
      .catch(formatAndRaiseError)
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return { retrieve, data, loading, error };
}
